import React from 'react';

const Terms = () => {
    return (
        <div className="container-xxl py-5">
            <div className="container">
                <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                    <h6 className="section-title bg-white text-center text-primary px-3">Legal</h6>
                    <h1 className="mb-5">Terms of Service</h1>
                </div>
                <div className="row g-4">
                    <div className="col-lg-12">
                        <h2>1. Agreement to Terms</h2>
                        <p>
                            By using our services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
                        </p>

                        <h2>2. Intellectual Property Rights</h2>
                        <p>
                            Unless otherwise indicated, the platform is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the site are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws.
                        </p>

                        <h2>3. User Representations</h2>
                        <p>
                            By using the platform, you represent and warrant that: (1) all registration information you submit will be true, accurate, current, and complete; (2) you will maintain the accuracy of such information and promptly update such registration information as necessary; (3) you have the legal capacity and you agree to comply with these Terms of Service.
                        </p>

                        <h2>4. Prohibited Activities</h2>
                        <p>
                            You may not access or use the platform for any purpose other than that for which we make the platform available. The platform may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us.
                        </p>
                        
                        <h2>5. Term and Termination</h2>
                        <p>
                            These Terms of Service shall remain in full force and effect while you use the platform. WITHOUT LIMITING ANY OTHER PROVISION OF THESE TERMS OF SERVICE, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE PLATFORM (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON.
                        </p>

                        <h2>6. Modifications and Interruptions</h2>
                        <p>
                            We reserve the right to change, modify, or remove the contents of the platform at any time or for any reason at our sole discretion without notice. We also reserve the right to modify or discontinue all or part of the platform without notice at any time.
                        </p>

                        <h2>7. Contact Us</h2>
                        <p>
                            In order to resolve a complaint regarding the platform or to receive further information regarding use of the platform, please contact us at contact@fundisha.com.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Terms; 